import React, { useState, useEffect } from "react";
import { ArrowForward, BoltOutlined, ChatBubbleOutline, ChevronRight } from "@mui/icons-material"
import { Button, Modal, Skeleton } from "@mui/material"
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import fetch from "../Utils/fetch";
import _ from 'lodash';
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "./../Utils/styles.css"
import Countdown from 'react-countdown';
import { useNavigate } from "react-router-dom";
import { getsessionuser } from "../Utils/sessions";
import SignIn from "../Common/login";
import Universalheader from "../Headers/universalheader";
import Productsfour from "../Products/productsfour";
import { setAlert } from "../../store/alert";
import { setRecentlyViewed } from "../../store/recentlyViewed";
import { removeFromStore } from "../Utils/fn";
import ProductSlider from "../Products/ProductSlider";
import useDocumentTitle from "../../hooks/useDocumentTitle";
import { addSubProduct } from "../../store/subProducts";
import Homesliders from "./homesliders";
import Categoriesslider from "./categoriesslider";
import Searchbar from "../Components/searchbar";


const Home = ({ onrefresh }) => {

    const navigate = useNavigate()
    const [showsearchbar, setshowsearchbar] = useState(false);
    const dispatch = useDispatch();


    const now = new Date();
    const midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0); // Set to 00:00:00 of the current day
    const diff = midnight - now;

    const sliders = useSelector((state) => state.webSettings.data.WEB_SITE_SLIDERS);
    const categories = useSelector((state) => state.categories.data);
    const subProducts = useSelector((state) => state.subProducts.data);
    const recentlyViewed = useSelector((state) => state.recentlyViewed.data);
    const recentlySearched = useSelector((state) => state.recentlySearched.data);
    const webSettings = useSelector((state) => state.webSettings.data);
    const favorites = useSelector(state => state.favorites.data);
    const [conditions, setconditions] = useState([]);

    const fullName = webSettings.FULL_NAME;
    const sitename = fullName?.split(' ')[0];

    const [topSellingProducts, settopSellingProducts] = useState([]);


    const [categoriesGroups, setCategoriesGroups] = useState([]);
    const [bannerPos, setBannerPos] = useState(1);
    const [maxdiscount, setmaxdiscount] = useState(0);

    useDocumentTitle(webSettings.FULL_NAME);

    const [subProductsLoading, setSubProductsLoading] = useState(false);
    const [subProductsLoadingError, setSubProductsLoadingError] = useState('');

    useEffect(() => {
        loadSubProducts();
        window.scroll({ top: 0, behaviour: 'smooth' });
        filtercategories()
        loadtopselling()
    }, []);




    useEffect(() => {
        if (subProducts) {
            setBannerPos(Math.floor(subProducts?.length / 2) - 1);
        }
    }, [subProducts]);

    useEffect(() => {
        if (categories) {
            if (categories?.length > 11) {
                setCategoriesGroups(_.chunk(categories, 10));
            } else {
                setCategoriesGroups([categories]);
            }
        }
    }, [categories]);


   

    const filtercategories = async () => {
        const distinctarray = []
        try {
            const promises = categories.map(async (category) => {
                const res = await fetch.get('getProductsGroup', { group_code: category.item_group });
                const filterlist = res.list?.categories.filter((minicategory) => minicategory?.categoryCode !== 'GEN');
                return filterlist.map((element) => ({ ...element, item_group: category.item_group }));
            });

            const results = await Promise.all(promises);
            const finalconditions = results.flat(); // Combine all results into a single array
            //get distinct
            finalconditions.map((val, key) => {
                const categoryindex = distinctarray.findIndex((obj) => obj.categoryName == val.categoryName)
                if (categoryindex < 0) {
                    distinctarray.push(val)
                }
            })
            setconditions(distinctarray);
        } catch (error) {
            // Handle errors here
            console.error('An error occurred:', error);
        }
    };

    // Renderer callback with condition
    const renderer = ({ hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return <Completionist />;
        } else {
            // Render a countdown
            return <span> {hours}h :{minutes}m :{seconds}s</span>;
        }
    };

    function loadSubProducts() {
        if (subProducts?.length > 0) return;
        setSubProductsLoading(true);
        fetch
            .get('itemsandgroupscarousel')
            .then((res) => {
                setSubProductsLoading(false);
                dispatch(addSubProduct(res.list));

            })
            .catch((err) => {
                setSubProductsLoadingError(err.message);
                setSubProductsLoading(false);
                dispatch(setAlert({ type: 'error', message: 'Failed to get products. ' + err.message }));
            });
    }

    //fetch top selling products
    function loadtopselling() {
        fetch
            .get('getTodaysDeals')
            .then((res) => {
                if (res.list?.length > 0) {
                    gethighestpercentage(res.list)
                    settopSellingProducts(res.list)
                } else {
                    fetch
                        .get('getTopSellingProducts')
                        .then((res) => {
                            gethighestpercentage(res.list)
                            settopSellingProducts(res.list)
                        })
                }
            })
    }



    // Get highest percentage
    const gethighestpercentage = (array) => {
        if (array?.length > 0) {
            array.forEach(element => {
                element.discount = element?.amount_value ? Math.round(((parseFloat(element?.amount_value) - parseFloat(element.promotion_price)) / parseFloat(element?.amount_value)) * 100) : 0
            });

            const highestPercentage = Math.max(...array.map(o => o.discount));
            setmaxdiscount(highestPercentage);
        } else {
            setmaxdiscount(10)
        }
    };




    return (
        <div className="homebody">
            {showsearchbar && <Searchbar dismissmodals={() => setshowsearchbar(false)} products={subProducts?.flatMap((obj) => obj.items)} />}
            <Universalheader onshowsearchbar={() => setshowsearchbar(true)} />
            <div>
                <div className="wraphomesliders">
                    <Homesliders sliders={sliders} />
                </div>

                {/* <div className='wrapcategoriesslider'>
                    <Categoriesslider categories={categoriesToView} />
                </div> */}
                {recentlyViewed?.length > 0 &&
                    <div className="sections">
                        <section className="sectionheader" style={{ backgroundColor: "white" }}>
                            <h3>Recently Viewed</h3>
                            <Button onClick={() => navigate('/recents')} >SEE ALL</Button>
                        </section>
                        <Productsfour products={recentlyViewed} showoffer={true} />
                    </div>}
                {recentlySearched?.length > 0 &&
                    <div className="sections">
                        <section className="sectionheader" style={{ backgroundColor: "white" }}>
                            <h3>Last Searched</h3>
                            <Button onClick={() => navigate('/lastsearched')} >SEE ALL</Button>
                        </section>
                        <Productsfour products={recentlySearched} showoffer={true} />
                    </div>}
                <div className="sections">
                    <section className="flashsaleheader">
                        <div className="flashsaleleft">
                            <BoltOutlined sx={{ color: "orange" }} />
                            <div>
                                <div style={{ fontWeight: "bold" }}>Flash sales</div>
                                <div style={{ display: "flex", fontSize: 15, justifyContent: "center", alignItems: "center" }}>
                                    TIME LEFT: &nbsp;
                                    <div style={{ fontWeight: "bold", fontSize: 14 }}>
                                        <Countdown
                                            date={Date.now() + diff}
                                            renderer={renderer}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <Button color="secondary" onClick={() => navigate("/todays-deals")} endIcon={<ChevronRight />}>View All</Button>
                    </section>
                    <ProductSlider products={topSellingProducts} showquantity={true} showoffer={true} />
                </div>
                {subProducts?.length > 0 ?
                    subProducts.map((data, index) => (
                        <>
                            <div className="sections" key={data.group_name + index}>
                                <section className="sectionheader">
                                    <div className="sectionheadertitle">{_.startCase(_.lowerCase(data.group_name))}</div>
                                    <Button color="secondary" onClick={() => navigate(`/categoryitems`, { state: { category: data } })} endIcon={<ChevronRight />}>View All</Button>
                                </section>
                                <ProductSlider products={data.items} />
                            </div>
                        </>
                    )) :
                    <div>
                        {Array.from({ length: 20 }, (_, index) => {
                            return (
                                <div>
                                    <Skeleton variant="rectangular" sx={{ height: 50, width: 450, marginBottom: 2 }} />
                                    <ProductSlider products={[]} />
                                </div>
                            )
                        })}
                    </div>
                }
                {favorites?.length > 0 &&
                    <div className="sections">
                        <section className="sectionheader" style={{ backgroundColor: "white" }}>
                            <h3>Saved Items</h3>
                            <Button onClick={() => navigate('/saveditems')} >SEE ALL</Button>
                        </section>
                        <Productsfour products={favorites} showoffer={true} />
                    </div>}

            </div>
        </div>
    )
}

export default Home